import { useLocalization } from "@progress/kendo-react-intl";
import {  useEffect, useRef, useState } from "react";
import { AccessToken } from "../config/AccessToken";
import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import {
  TransformWrapper,
  TransformComponent,
  useControls
} from "react-zoom-pan-pinch";
import { Checkbox, Switch } from "@progress/kendo-react-inputs";

import { loadingPanel } from "../components/LoadingPanel";
import { AzureMapComponent } from "./AzureMapComponent"; 
import { useNavigate } from "react-router-dom";
import { Avatar } from "@progress/kendo-react-layout";
import { SvgIcon } from "@progress/kendo-react-common";
import { trashIcon } from "@progress/kendo-svg-icons";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { currentLocation } from "../assets/current-location";
import { filterBy } from "@progress/kendo-data-query";


/**
 * Component that displays and manages a map interface with various functionalities.
 * It allows users to interact with maps, zones, groups, beacons, and alarms.
 * Handles data fetching from server and local storage, and renders map layers and markers.
 * Provides options to toggle live updates, and to manage selections using checkboxes and dropdowns.
 * 
 * @param {Object} props - The properties passed to the component.
 */
export const Maps = (props: any) => {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  const localizationService = useLocalization();
  const [instance, accessTokenRequest] = AccessToken();

  const [selectedMap, setSelectedMap] = useState<any>([]);

  const [listMaps, setListMaps] = useState([]);
  const [mapName, setMapName] = useState([]);
  const [listMapNames, setListMapNames] = useState([]);

  const [zonesCheckboxByMap, setZonesCheckboxByMap] = useState<any>([]);
  const [zoneCheckedList, setZoneCheckedList] = useState<any>([]);

  const [groupsCheckedList, setGroupsCheckedList] = useState<any>([]);
  const [groupsCheckboxByMap, setGroupsCheckboxByMap] = useState<any>([]);
  const [groupsChecked, setGroupsChecked] = useState<any>([]);
  const [groupChanged, setGroupChanged] = useState<any>(false);

  const [allBeacons, setAllBeacons] = useState([]);
  const [listBeaconsOn, setListBeaconsOn] = useState<any>([]);

  const [currentZoneCanvas, setCurrentZoneCanvas] = useState<any>([]);

  const [mapGeoreferenced, setMapGeoreferenced] = useState(false);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate()
  
  let mapCanvas: any = useRef()
  const mapCtx = mapCanvas?.current?.getContext("2d");
  
  const zoneCanvas: any = useRef();
  const groupCanvas: any = useRef();
  const beaconCanvas: any = useRef();
  const alarmCanvas: any = useRef();

  const deviceMapId: any = localStorage.getItem('deviceMapId')
  const deviceGroupId: any = localStorage.getItem('deviceGroupId')
  const deviceMac: any = localStorage.getItem('deviceMac') 
  const beaconMapId: any = localStorage.getItem('beaconMapId')
  const beaconId: any = localStorage.getItem('beaconId')
  const alarmInfoSelected: any = JSON.parse(localStorage.getItem('alarmInfoSelected') as string)

  const [alarmChecked, setAlarmChecked] = useState<any>(alarmInfoSelected);
  const [alarmToggle, setAlarmToggle] = useState<any>(false);
  const [alarmInfo, setAlarmInfo] = useState<any>([]);

  const [liveStatus, setLiveStatus] = useState<any>(false);
  const [mapId, setMapId] = useState<any>(null);
  
  const [deviceMacSelected, setDeviceMacSelected] = useState<any>(deviceMac);
  const [showDeviceMac, setShowDeviceMac] = useState<any>(false);
  const [noPositionFound, setNoPositionFound] = useState<any>(false);

  const [onlyBound, setOnlyBound] = useState<any>(false);
  const [toggleGeoStatic, setToggleGeoStatic] = useState<any>(true);
  const [noMaps, setNoMaps] = useState<any>(false);

  
  let languageId = localStorage.getItem('languageId');

  useEffect(() => {
    getMapList()
  }, []);
  
  useEffect(() => {
    const mapId:any = localStorage.getItem('mapId')
    setMapId(mapId)
  }, [localStorage.getItem('mapId')]);

  useEffect(() => {
        
    if (zoneCanvas.current != null) {
      setCurrentZoneCanvas(zoneCanvas);
    }

    if (mapCtx != null && mapCanvas.current != null) {
      renderMap(selectedMap);
    }
  }, [mapGeoreferenced]);

  // reset localstorage on page load 
  useEffect(() => {
    localStorage.setItem('mapsList', '');
    localStorage.setItem('zonesChecked', '');
    localStorage.setItem('groupChecked', '');
    localStorage.setItem('noGroupChecked', '');
    localStorage.setItem('devicesWithGroupToShowInMap', '');
    localStorage.setItem('devicesWithNoGroupToShowInMap', '');
    localStorage.setItem('wakeupGroupsMapGeo', '');
    localStorage.removeItem('beaconsByMapId');
    localStorage.removeItem('onlyBoundMap');
    //localStorage.setItem('listGroups', '');
    setShowDeviceMac(false);
  }, [])

  const getMapList = async () => {

    setLoading(true);

    localStorage.setItem('mapId', '');

    const commonOperations = (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      axios.get(`${SERVER_URL}/map/full/list`, { headers })
        .then((res) => {
          const data = res?.data.data

          if(data.length == 0){
            setNoMaps(true)
          }

          let mapsList: any = []
          let mapNames: any = []
          let mapImages: any = []
          let mainMap: any = ''
          data?.forEach((map: any) => {
            mapsList.push(map)
            mapNames.push(map.name)
            mapImages.push(map.image)
            if (map.main == '1') {
              mainMap = map
            }else{
              //mainMap = map
            }
          });
          setListMaps(mapsList)
          setListMapNames(mapNames)
          getGroupList()  
          if(deviceMac != null){             

            const mapSelected = deviceMapId != null ? mapsList.find((map:any) => map.id == deviceMapId) : mapsList[0];

            localStorage.setItem('mapSelected', JSON.stringify(mapSelected))
            const mapIdSelected = mapSelected.id
            localStorage.setItem('mapId', JSON.stringify(mapIdSelected))
            handleChangeMap(mapSelected, false, mapsList)        
            getMapById(mapSelected.id)
            wakeUpGroupByMapId(mapSelected.id, mapSelected.georeferenced)
            setShowDeviceMac(true)
            if(deviceMapId == null){
              setNoPositionFound(true)
  
              setTimeout(() => {
                setNoPositionFound(false)
              }, 5000);
              return
            }
          }else{     
            //getGroupList()     
            if (mapsList != null) {
              if (beaconMapId != null) {
                const mapSelected = mapsList.find((map:any) => map.id == beaconMapId);
                getBeaconList(beaconMapId, true, true, mapSelected.georeferenced, mapsList)
                localStorage.setItem('mapSelected', JSON.stringify(mapSelected))
                localStorage.setItem("mapId", JSON.stringify(beaconMapId))                
                return
              }
              if (alarmInfoSelected != null) {
                localStorage.setItem("alarmInfoSelected", JSON.stringify(alarmInfoSelected))                
                setAlarmChecked(alarmInfoSelected)
                setAlarmInfo(alarmInfoSelected)
                getAlarmPositionByWakeupId(alarmInfoSelected.info.id, mapsList)
                handleChangeAlarm(true)
                alarmChecked.checked = true
                return;
              }
              if(mainMap.main == 1){
                handleChangeMap(mainMap)
                localStorage.setItem("mapId", JSON.stringify(mainMap.id))
                const mapSelected = mapsList.find((map:any) => map.id == deviceMapId);
                localStorage.setItem('mapSelected', JSON.stringify(mapSelected))
              }else{
                localStorage.setItem("mapId", '-1')
                localStorage.setItem('mapSelected', JSON.stringify(mapsList[0]))
                handleChangeMap(mapsList[0], false, mapsList)              
                getMapById(alarmInfoSelected.mapId)
                wakeUpGroupByMapId(alarmInfoSelected.mapId, mapsList[0].georeferenced)
              }                              
            }
            
            if(mainMap.main == 1){
              handleChangeMap(mainMap, false, mapsList)
              localStorage.setItem("mapId", JSON.stringify(mainMap.id))
              const mapSelected = mainMap
              localStorage.setItem('mapSelected', JSON.stringify(mapSelected))
            }else{
              localStorage.setItem("mapId", '-1')
              localStorage.setItem('mapSelected', JSON.stringify(mapsList[0]))
              handleChangeMap(mapsList[0], false, mapsList)              
              getMapById(mapsList[0].id)
              wakeUpGroupByMapId(mapsList[0].id, mapsList[0].georeferenced)
            }            
            
          }
          setLoading(false)
        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
        });
        setLoading(false)
    }

    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          //setLoading(false);
        });
    }
  }

  useEffect(() => {
    handleChangeAlarm(true)
  }, [loading])

  // refresh groups positions in map
  useEffect(() => {
    const refreshAPI:any = localStorage.getItem('refreshAPI')
    const interval = setInterval(async () => {
      let mapId = localStorage.getItem('mapId')

      //if(mapId != null && mapId != '') return

      if (localStorage.getItem('mapGeorefenced') == 'false' && mapId != '-1' && mapId != '') {
        refreshGroupPositionsInStaticMap(localStorage.getItem('mapId'))
      }
      if (localStorage.getItem('mapGeorefenced') == 'true') {
        refreshGroupPositionsInMapGeo(localStorage.getItem('mapId'), true)
      }
    }, refreshAPI * 1000);       

    return () => clearInterval(interval);
  }, [])

  const Controls = () => {
    const { zoomIn, zoomOut, resetTransform } = useControls();

    return (
      <div className="k-button" style={{ border:'1px solid transparent'}}>
        <button 
          //className="k-button-solid-primary" 
          style={{
            position: 'absolute',
            width: '32px',
            height: '32px',
            zIndex: 10,
            top: '0px',
            left: '10px',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            cursor: 'pointer'
          }}
          title={localizationService.toLanguageString('map.zoom_in', 'NOT_FOUND')}
          onClick={() => zoomIn()}>+</button>
        <button 
          style={{
            position: 'absolute',
            width: '32px',
            height: '32px',
            zIndex: 10,
            top: '0px',
            left: '47px',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            cursor: 'pointer'
          }} 
          title={localizationService.toLanguageString('map.zoom_out', 'NOT_FOUND')}
          onClick={() => zoomOut()}>-</button>
        <button 
          style={{
            position: 'absolute',
            width: '32px',
            height: '32px',
            zIndex: 10,
            top: '0px',
            left: '84px',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            cursor: 'pointer'
          }}   
          title={localizationService.toLanguageString('map.reset_zoom', 'NOT_FOUND')}
          onClick={() => resetTransform()}>
           <SvgIcon icon={currentLocation} />
        </button>
      </div>
    );
  };

  const stringToBoolean = (str:any) => {
    return str.toLowerCase() === 'true';
  }

  const [mapImageWidth, setMapImageWidth] = useState<any>(0);
  const [mapImageHeight, setMapImageHeight] = useState<any>(0);

  const renderMap = (map: any) => {

    const isMapGeo:any = stringToBoolean(localStorage.getItem('mapGeorefenced'))
    
    if ((map?.georeferenced == 0 || !isMapGeo) && mapCtx != null) {

      mapCtx?.clearRect(0, 0, mapCtx?.canvas.width, mapCtx?.canvas.height)
      let width: any = 0
      //let height: any = 0

      width = mapCtx?.canvas.parentElement.offsetWidth != 0 ? mapCtx?.canvas.parentElement.offsetWidth : 1400;
      //height = mapCtx?.canvas.parentElement.offsetHeight != 0 ? mapCtx?.canvas.parentElement.offsetHeight : 1400;

      let backgroundCanvas = new Image();

      localStorage.setItem('mapImage', map?.image)
      let mapImageItem:any = localStorage.getItem('mapImage' + map?.image) ?? map?.image;
      if (mapImageItem !== null) {        
        backgroundCanvas.src = `data:image/jpeg;base64, ${mapImageItem}`;
      } else {
        backgroundCanvas.src = `data:image/jpeg;base64, ${map?.image}`;
      }

      backgroundCanvas.onload = () => {
        let wImg = backgroundCanvas.width;
        let hImg = backgroundCanvas.height;
        
        let height = width * hImg / wImg;
        mapCanvas.height = zoneCanvas.height = groupCanvas.height = beaconCanvas.height = alarmCanvas.height = height;
        mapCanvas.width = zoneCanvas.width = groupCanvas.width = beaconCanvas.width = alarmCanvas.width = width;
        mapCanvas.current.style.backgroundImage = 'url(' + backgroundCanvas.src + ')';
        mapCtx?.drawImage(backgroundCanvas, 0, 0, mapCanvas.width, mapCanvas.height);
        
        setMapImageWidth(mapCanvas.width)
        setMapImageHeight(mapCanvas.height)
      };

      setMapGeoreferenced(false)
    } else {
      localStorage.setItem('mapImage', map?.image)
      setMapGeoreferenced(true)
    }
  }

  const handleChangeMap = (event: any, fromMap?: boolean, mapsList?:any) => {

    setNoPositionFound(false)

    let currMap:any = ''
    if(event?.value != undefined){
      currMap = event?.value ?? event ?? ''
    }else{
      currMap = event.name ?? event ?? ''
    }

    setMapGeoreferenced(true)

    setZoneCheckedList([])
    setZonesCheckboxByMap([])
    setGroupsCheckboxByMap([])
    setListBeaconsOn([])
    setSelectedBeacons([])
    setToggleGeoStatic(true)
    
    localStorage.setItem('liveStatus', 'false');
    setLiveStatus(false);
    
    localStorage.removeItem('zonesChecked');
    
    setAlarmInfo([])

    if(fromMap){
      setAlarmChecked(null)
    }
    
    const currListMaps: any = listMaps.length > 0 ? listMaps : mapsList

    const isMapGeo = currListMaps?.find((map: any) => map.name == currMap)?.georeferenced   
    const convertedValue:any = isMapGeo == 0 ? false : true 
    localStorage.setItem('mapGeorefenced', convertedValue)

    let mapSelected = currListMaps?.find((map: any) => map.name == currMap)

    const updateMapSelected = mapSelected ?? currListMaps?.find((map: any) => map.id == currMap)
    
    renderMap(updateMapSelected);
    getMapById(updateMapSelected?.id) // inizialize the mapCanvas
    
    const isGeoreferenced = updateMapSelected?.georeferenced == 1 ? true : false
    getZoneList(updateMapSelected.id, isGeoreferenced)

    getBeaconList(updateMapSelected.id, true, false, updateMapSelected.georeferenced, currListMaps, true)
    
    setSelectedMap(updateMapSelected)
    setMapName(updateMapSelected.name)
    wakeUpGroupByMapId(updateMapSelected.id, isGeoreferenced)
    
    localStorage.setItem("mapSelected", JSON.stringify(updateMapSelected))
    localStorage.setItem("mapId", updateMapSelected.id)
    
    //if(isMapGeo == 0){  

      const mapCtx = mapCanvas?.current?.getContext("2d");
      const mapWidth = mapCanvas?.width ?? mapCanvas?.current?.width
      const mapHeight = mapCanvas?.height ?? mapCanvas?.current?.height
      mapCtx?.clearRect(0, 0, mapWidth, mapHeight)

      const zoneCtx = zoneCanvas?.current?.getContext("2d");
      const zoneWidth = zoneCanvas?.width ?? zoneCanvas?.current?.width
      const zoneHeight = zoneCanvas?.height ?? zoneCanvas?.current?.height
      zoneCtx?.clearRect(0, 0, zoneWidth, zoneHeight)

      const groupCtx = groupCanvas?.current?.getContext("2d");
      const groupWidth = groupCanvas?.width ?? groupCanvas?.current?.width
      const groupHeight = groupCanvas?.height ?? groupCanvas?.current?.height
      groupCtx?.clearRect(0, 0, groupWidth, groupHeight)

      const beaconCtx = beaconCanvas?.current?.getContext("2d");
      const beaconWidth = beaconCanvas?.width ?? beaconCanvas?.current?.width
      const beaconHeight = beaconCanvas?.height ?? beaconCanvas?.current?.height
      beaconCtx?.clearRect(0, 0, beaconWidth, beaconHeight)

      const alarmCtx = alarmCanvas?.current?.getContext("2d");
      const alarmWidth = alarmCanvas?.width ?? alarmCanvas?.current?.width
      const alarmHeight = alarmCanvas?.height ?? alarmCanvas?.current?.height
      alarmCtx?.clearRect(0, 0, alarmWidth, alarmHeight)
    //}
         
  }

  const getMapById = async (mapId: number) => {

    setLoading(true);

    const commonOperations = (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      axios.get(`${SERVER_URL}/map/${mapId}`, { headers })
        .then((res) => {
          const data = res.data.data

          let infoMapSelected: any = []
          let botLeft: any = []
          let topLeft: any = []
          let botRight: any = []
          let topRight: any = []

          infoMapSelected.push(data)
          botLeft.push(data.botLeft)
          topLeft.push(data.topLeft)
          botRight.push(data.botRight)
          topRight.push(data.topRight)

          setMapName(data.name)

          if (data.georeferenced == 1) {
            setMapGeoreferenced(true)
            localStorage.setItem('mapGeorefenced', 'true')
            localStorage.setItem('checkedGroupMarker', JSON.stringify(false))
          } else {
            setMapGeoreferenced(false)
            localStorage.setItem('mapGeorefenced', 'false')
          }
          
          if (deviceGroupId != null) {
            handleChangeGroup(true, deviceGroupId, true)    
          }

          setLoading(false);
        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
        });
    }

    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
          setLoading(false);
        });
    }
    setLoading(false);
  }

  const getZoneList = async (mapId: number, isGeoreferenced?: boolean) => {

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      axios.get(`${SERVER_URL}/zone/bymapid/${mapId}?isGeoreferenced=${isGeoreferenced}`, { headers })
        .then((res) => {
          const data = res?.data?.data

          let listZones: any = []
          let listZonesSelected: any = []
          let listZoneNames: any = []
          
          // add a checkbox All Zones
          listZones.push({
            id: '0',
            name: localizationService.toLanguageString('map.selectAll', 'NOT_FOUND'),
            color: 'white'
          })

          data?.forEach((zone: any, id: any) => {
            listZones.push(zone)
            listZoneNames.push(zone.name)
            listZonesSelected.push({
              id: zone.id,
              name: zone.name,
              color: zone.color,
              points: zone.points
            })
          });

          setZonesCheckboxByMap(listZones)
        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
          setLoading(false);
          navigate("/")
        });
    }
    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
        });
    }
  }

  const getGroupList = async () => {

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      axios.get(`${SERVER_URL}/group/list`, { headers })
        .then((res) => {
          const data:any = res.data.data

          if(data[0].id == '-1'){
            data[0].name = localizationService.toLanguageString('map.noGroup', 'NOT_FOUND')
          }else{
            data[1].name = localizationService.toLanguageString('map.noGroup', 'NOT_FOUND')
          }
          
          localStorage.setItem('listGroups', JSON.stringify(data));
          
          //select all groups by default 
          data?.forEach((group: any) => {
            groupsCheckboxByMap.push(group)
          })
          
          let devicesToShowInMap = localStorage.getItem('devicesWithGroupToShowInMap')
          devicesToShowInMap = groupsCheckboxByMap ?? devicesToShowInMap         
          
          setGroupsChecked(devicesToShowInMap)
        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
        });
    }
    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
        });
    }
  }

  const getBeaconList = async (mapId: number, flag: boolean, fromBeaconGrid?: boolean, isMapGeoreferenced?:any, mapsList?:any, toggleGeoStatic?:any) => {

    setLoading(true);

    const convertGeoMap = isMapGeoreferenced == '1' ? true : false

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      const params = {
        enabled: flag,
        isGeoreferenced: convertGeoMap
      };
      //await axios.get(`${SERVER_URL}/beacon/list`, { headers, params })
      await axios.get(`${SERVER_URL}/beacon/${mapId}`, { headers, params })
        .then((res) => {
          const data = res?.data?.data

          let beaconsByMapId: any = []

          // add a checkbox All Beacons
          beaconsByMapId.push({
            id: '0',
            name: localizationService.toLanguageString('map.selectAll', 'NOT_FOUND'),
            color: 'white',
            checked: false //true
          })

          data?.forEach((beacon: any) => {
            if (beacon.mapId != mapId) {
              return;
            } else {
              //beacon.checked = true
              beaconsByMapId.push(beacon)
            }
            beacon.checked = false
          });

          if (flag) {
            // format date in data.data
            beaconsByMapId.forEach((beacon: any) => {
              if (beacon?.lastSeen == null) {
                beacon.lastSeen = localizationService.toLanguageString('beacons.date_not_found', 'NOT_FOUND')
                return
              }
              beacon.lastSeen = beacon?.lastSeen?.split('T')[0]

              //format alarm.dateTime with gg/mm/yyyy
              const date = new Date(beacon?.lastSeen);
              const day = date?.getDate();

              const month = (date.getMonth() + 1).toString().padStart(2, "0");
              const year = date.getFullYear();
              beacon.lastSeen = new Date(`${year},${month},${day}`)
            })
            if(localStorage.getItem('beaconId') == null){
              setListBeaconsOn(beaconsByMapId);              
              setAllBeacons(beaconsByMapId);              
            }

          }

          if (fromBeaconGrid) {
            beaconsByMapId.forEach((beacon: any) => {
              if (beacon.id == beaconId) {
                beacon.checked = true
                getMapByPosition(beacon.longitude, beacon.latitude, beacon.elevation, null, mapsList)
                beaconsByMapId.shift()
                const beaconFromGrid = beaconsByMapId.filter((b: any) => beacon.id.includes(b.id))
                setSelectedBeacons(beaconFromGrid)
              }
            });
            handleChangeBeacon(true, beaconId, beaconsByMapId)
          }

          if(!toggleGeoStatic && !fromBeaconGrid){
            const updatedListBeaconCheckbox = beaconsByMapId.map((beacon:any) => {
              return {
                ...beacon, // Create a new object based on the existing beacon
                checked: false, // Override the checked property
              };
            })
            setListBeaconsOn(updatedListBeaconCheckbox)
            setAllBeacons(updatedListBeaconCheckbox)
          }

          setLoading(false);
        }).catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
          setLoading(false);
        });
    }

    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
          setLoading(false);
        });
    }
  }

  const getMapByPosition = async (positionX:any, positionY:any, elevation:any, orientation?:any, mapsList?:any) => {

    setLoading(true)

    const params:any = {
        longitude: positionX,
        latitude: positionY,
        elevation: elevation,
        ...(orientation != null && { orientation }) 
    }

    const commonOperations = (accessToken: any) => {
        const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
        axios.post(`${SERVER_URL}/map/position`, params, {headers})
            .then((res) => {
                const data = res.data.data

                if(data?.length == 0) return

                const mapInfo = data
                const mapId = data.id
                const isGeoreferenced = data.georeferenced

                getMapById(mapId)
                handleChangeMap(mapInfo, false, mapsList)              
                wakeUpGroupByMapId(mapId, isGeoreferenced)

                setLoading(false)
            })
            .catch((error) => {
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect(accessTokenRequest);
                }
                console.log(error);
                setLoading(false)
            });
    }

    if (sessionStorage.getItem('accessToken') != null) {
        let accessToken = sessionStorage.getItem('accessToken');
        commonOperations(accessToken);
    } else {
        await instance.initialize();
        await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
            let accessToken = accessTokenResponse.accessToken;
            commonOperations(accessToken);
        })
            .catch((error: any) => {
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect(accessTokenRequest);
                }
                console.log(error);
                setLoading(false)
            });
    }
  }

  const wakeUpGroupByMapId = async (mapId: any, isGeoreferenced?:any, onlyBound?:any) => {

    //setLoading(true)

    isGeoreferenced = isGeoreferenced == 1 ? true : false

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      axios.get(`${SERVER_URL}/map/${mapId}/wakeups?isGeoreferenced=${isGeoreferenced}`, { headers })
        .then((res) => {
          const data = res?.data?.data

          //if(deviceMapId == null){
          //  setNoPositionFound(true)

          //  setTimeout(() => {
          //    setNoPositionFound(false)
          //  }, 5000);
          //  return
          //}

          const devicesList: any = []
          const deviceGroupId: any = []
          data.forEach((device: any) => {
            deviceGroupId.push(device.groupId)
            
            if(onlyBound){ 
              groupsCheckedList.forEach((group: any) => {
                if(group.id == device.groupId){
                  if(device?.name == '' || device?.name == null){
                    return
                  }                  
                }
              })
            }
            
            devicesList.push(device)
          });

          localStorage.setItem('devicesList', JSON.stringify(devicesList))
                
          const groupsCheckboxByMap: any = []
          const listGroups = JSON.parse(localStorage.getItem('listGroups') as string)

          // add a checkbox "Select all"
          groupsCheckboxByMap.push({
            id: '0',
            name: localizationService.toLanguageString('map.selectAll', 'NOT_FOUND'),
            color: 'white'
          })
          
          // add a checkbox "Unassigned"
          groupsCheckboxByMap.push({
            id: '1',
            name: localizationService.toLanguageString('map.noGroup', 'NOT_FOUND'),
            color: 'lightgrey'
          })

          // populate the checkbox group
          listGroups?.forEach((group: any) => {       
            if (deviceGroupId.includes(group.id)) {
              groupsCheckboxByMap.push({
                id: group?.id,
                name: group?.name,
                color: group?.color
              })
            }
          })

          localStorage.setItem('groupsCheckboxByMap', JSON.stringify(groupsCheckboxByMap));

          setGroupsCheckboxByMap(groupsCheckboxByMap)

          // populate groups array in map
          const markersWithGroupToShowInMap: any = []
          const markersWithNoGroupToShowInMap: any = []
          data.forEach((device: any) => {
            
            //if (device?.groupId != null && listGroups != null) { // retrieve groupId
            if (listGroups != null) { // retrieve groupId

              //retrieve the device's group's name
              const deviceGroupName:any = listGroups.find((g: any) => g.id == device.groupId)

              if(deviceGroupName != undefined){                                  
                markersWithGroupToShowInMap.push({
                  id: device?.id,
                  mac: device?.deviceMac,
                  name: device?.name,
                  groupId: device?.groupId,
                  color: deviceGroupName?.color,
                  position: {
                    latitude: device.position?.latitude,
                    longitude: device.position?.longitude,
                    elevation: device.position?.elevation,
                    orientation: device.position?.orientation
                  }
                })
              }
              else {
                //console.log(device);
                markersWithNoGroupToShowInMap.push({
                  id: device?.id,
                  mac: device?.deviceMac,
                  groupId: device?.groupId,
                  position: {
                    latitude: device.position?.latitude,
                    longitude: device.position?.longitude,
                    elevation: device.position?.elevation,
                    orientation: device.position?.orientation
                  },
                  name: localizationService.toLanguageString('map.noGroup', 'NOT_FOUND'),
                  color: 'lightgrey'
                })
              }
            }
          })

          localStorage.setItem('devicesWithGroupToShowInMap', JSON.stringify(markersWithGroupToShowInMap));
          localStorage.setItem('devicesWithNoGroupToShowInMap', JSON.stringify(markersWithNoGroupToShowInMap));

          const allMarkersToShowInMap = markersWithGroupToShowInMap.concat(markersWithNoGroupToShowInMap);

          localStorage.setItem('groupChecked', JSON.stringify(allMarkersToShowInMap))

          setGroupsChecked(allMarkersToShowInMap)

        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          //setLoading(false)
        });
    }

    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
        });
    }
  }

  const refreshGroupPositionsInStaticMap = async (mapId: any) => {

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      await axios.get(`${SERVER_URL}/map/${mapId}/wakeups?isGeoreferenced=false`, { headers })
        .then((res) => {

          const groupCtx = groupCanvas?.current?.getContext("2d");
          groupCtx?.clearRect(0, 0, groupCanvas.width, groupCanvas.height)
          
          const data = res?.data?.data

          let currListGroup = JSON.parse(localStorage.getItem('listGroups') || '[]')

          // populate groups array in map
          const devicesWithGroupToShowInMap: any = []
          const devicesWithNoGroupToShowInMap: any = []

          const liveStatus = JSON.parse(localStorage.getItem('liveStatus') || 'false')
          const onlyBound = JSON.parse(localStorage.getItem('onlyBoundMap') || 'false')

          if(liveStatus){
            let devicesLiveWithGroupToShowInMap:any = JSON.parse(localStorage.getItem('devicesWithGroupToShowInMap') || '[]')  
            if(devicesLiveWithGroupToShowInMap.length > 0 || devicesLiveWithGroupToShowInMap[0].length > 0){                    
              devicesLiveWithGroupToShowInMap.forEach((deviceLive: any) => {            
                
                if(onlyBound){
                  if(deviceLive?.name == '' || deviceLive?.name == null){
                    return
                  }
                }

                let deviceGroup:any = currListGroup.find((group:any) => group.id == deviceLive.groupId)
                let colourDeviceGroup:any = deviceGroup?.color
                devicesWithGroupToShowInMap.push({
                  id: deviceLive?.id,
                  mac: deviceLive?.deviceMac,
                  name: deviceLive?.name,
                  groupId: deviceLive?.groupId,
                  color: colourDeviceGroup,
                  checked: true,
                  position: {
                    latitude: deviceLive?.position?.latitude,
                    longitude: deviceLive?.position?.longitude,
                    elevation: deviceLive?.position?.elevation,
                    orientation: deviceLive?.position?.orientation
                  }
                })
              })
            }
            else{
              devicesWithGroupToShowInMap.push(devicesLiveWithGroupToShowInMap)
            }
          }
          else{
            data.forEach((device: any) => {

              if(onlyBound){
                if(device?.name == '' || device?.name == null){
                  return
                }
              }

              if (device?.groupId != null && currListGroup != null) {                    
                if (currListGroup.find((group:any) => group.id == device.groupId)?.id) {
                  devicesWithGroupToShowInMap.push({
                    id: device?.id,
                    mac: device?.deviceMac,
                    name: device?.name,
                    groupId: device?.groupId,
                    color: device?.groupColor,
                    //color: listGroup?.color,
                    checked: true,
                    position: {
                      latitude: device?.position?.latitude,
                      longitude: device?.position?.longitude,
                      elevation: device?.position?.elevation,
                      orientation: device?.position?.orientation
                    }
                  })
                }
              }
              else {
                currListGroup?.forEach(() => {
                  devicesWithNoGroupToShowInMap.push({
                    id: device?.id,
                    mac: device?.deviceMac,
                    name: device?.name,
                    groupId: device?.groupId,
                    color: 'lightgrey',
                    checked: true,
                    position: {
                      latitude: device?.position?.latitude,
                      longitude: device?.position?.longitude,
                      elevation: device?.position?.elevation,
                      orientation: device?.position?.orientation
                    }
                  })
                })
              }
            })
          }

          localStorage.setItem('devicesWithGroupToShowInMap', JSON.stringify(devicesWithGroupToShowInMap))
          localStorage.setItem('devicesWithNoGroupToShowInMap', JSON.stringify(devicesWithNoGroupToShowInMap))

          const getDifference = (listGroupChecked: any, devicesWithGroupToShowInMap: any) => {
            const diffFromA1toA2 = listGroupChecked.filter((obj1: any) =>
              !devicesWithGroupToShowInMap.some((obj2: any) => obj1.groupId === obj2.groupId || obj1.id === obj2.groupId)
            );

            const diffFromA2toA1 = devicesWithGroupToShowInMap.filter((obj2: any) =>
              listGroupChecked.some((obj1: any) => obj2.groupId === obj1.groupId || obj2.groupId === obj1.id)
            );

            diffFromA2toA1.checked = true
            diffFromA1toA2.checked = true

            return [...diffFromA1toA2, ...diffFromA2toA1];
          }

          /* update the grouped devices position  */
          let updatedListGroupsChecked: any[] = []
          const groupChecked: any = localStorage.getItem('groupChecked')
          if (groupChecked != '[]' && groupChecked != '') {
            const groupsChecked: any = JSON.parse(groupChecked)
            updatedListGroupsChecked = (getDifference(groupsChecked, devicesWithGroupToShowInMap));
          }

          /* update the no-grouped devices position  */
          const updatedListNoGroupChecked: any[] = []
          let noGroupChecked: any = localStorage.getItem('noGroupChecked')
          if (noGroupChecked != '[]' && noGroupChecked != '') {
            devicesWithNoGroupToShowInMap.forEach((updatedGroup: any) => {
              updatedListNoGroupChecked.push(updatedGroup);
            });
          }
                    
          // re-render the group canvas after deleting a group deselected
          if (devicesWithGroupToShowInMap.length > 0) {
            //localStorage.setItem('groupChecked', JSON.stringify(allMarkersToShowInMap))
            localStorage.setItem('groupChecked', JSON.stringify(devicesWithGroupToShowInMap))
            const groupCtx = groupCanvas?.current?.getContext("2d");
            devicesWithGroupToShowInMap.forEach((group: any) => {
              groupCtx.fillStyle = group?.color
              groupCtx.lineWidth = 2;
              groupCtx.strokeStyle = 'black';
              groupCtx.beginPath();
              groupCtx.arc(Math.round(groupCanvas.width * group?.position?.longitude) - 5, Math.round(groupCanvas.height - groupCanvas.height * group?.position?.latitude) - 5, 10, 0, Math.PI * 2);
              groupCtx.closePath();
              groupCtx.fill();
              groupCtx.stroke();
            });
          }

          // re-render the ungrouped group canvas after deleting a ungrouped group deselected
          if (updatedListNoGroupChecked.length > 0) {
            localStorage.setItem('noGroupChecked', JSON.stringify(updatedListNoGroupChecked))
            const groupCtx = groupCanvas?.current?.getContext("2d");
            updatedListNoGroupChecked.forEach((group: any) => {
              groupCtx.fillStyle = 'lightgrey' //group?.color ?? 'white'
              groupCtx.lineWidth = 2;
              groupCtx.strokeStyle = 'black';
              groupCtx.beginPath();
              groupCtx.arc(Math.round(groupCanvas.width * group?.position?.longitude) - 5, Math.round(groupCanvas.height - groupCanvas.height * group?.position?.latitude) - 5, 10, 0, Math.PI * 2);
              groupCtx.closePath();
              groupCtx.fill();
              groupCtx.stroke();
            });
          }
        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
        });
    }
    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
        });
    }
  }

  const refreshGroupPositionsInMapGeo = async (mapId: any, isGeoreferenced?:any) => {

    const commonOperations = (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      axios.get(`${SERVER_URL}/map/${mapId}/wakeups?isGeoreferenced=${isGeoreferenced}`, { headers })
        .then((res) => {

          const groupCtx = groupCanvas?.current?.getContext("2d");
          groupCtx?.clearRect(0, 0, groupCanvas.width, groupCanvas.height)

          const data = res?.data?.data

          let currListGroup = JSON.parse(localStorage.getItem('listGroups') || '[]')

          // populate groups array in map
          const devicesWithGroupToShowInMap: any = []
          const devicesWithNoGroupToShowInMap: any = []

          const liveStatus = JSON.parse(localStorage.getItem('liveStatus') || 'false')

          if(liveStatus){
            let devicesLiveWithGroupToShowInMap:any = JSON.parse(localStorage.getItem('devicesWithGroupToShowInMap') || '[]')  
            if(devicesLiveWithGroupToShowInMap.length > 0 || devicesLiveWithGroupToShowInMap[0].length > 0){                    
              devicesLiveWithGroupToShowInMap.forEach((deviceLive: any) => {      

                if(onlyBound){
                  if(deviceLive?.name == '' || deviceLive?.name == null){
                    return
                  }
                }

                let deviceGroup:any = currListGroup.find((group:any) => group.id == deviceLive.groupId)
                let colourDeviceGroup:any = deviceGroup?.color
                devicesWithGroupToShowInMap.push({
                  id: deviceLive?.id,
                  name: deviceLive?.name,
                  groupId: deviceLive?.groupId,
                  color: colourDeviceGroup,
                  checked: true,
                  position: {
                    latitude: deviceLive?.position?.latitude,
                    longitude: deviceLive?.position?.longitude,
                    elevation: deviceLive?.position?.elevation,
                    orientation: deviceLive?.position?.orientation
                  }
                })
              })
            }
            else{
              devicesWithGroupToShowInMap.push(devicesLiveWithGroupToShowInMap)
            }
          }
          else{ 
               
            data.forEach((device: any) => {

              if(onlyBound){
                if(device?.name == '' || device?.name == null){
                  return
                }
              }

              if (device?.groupId != null && currListGroup != null) {
                currListGroup.forEach((listGroup: any, id: any) => {
                  if (device?.groupId == currListGroup[id]?.id) {
                    devicesWithGroupToShowInMap.push({
                      id: device?.id,
                      mac: device?.deviceMac,
                      name: device?.name,
                      groupId: device?.groupId,
                      color: listGroup?.color,
                      checked: true,
                      position: {
                        latitude: device?.position?.latitude,
                        longitude: device?.position?.longitude,
                        elevation: device?.position?.elevation,
                        orientation: device?.position?.orientation
                      }
                    })
                  }
                })
              }
              else {
                currListGroup.forEach((listGroup: any, id: any) => {                                    
                  devicesWithNoGroupToShowInMap.push(...devicesWithNoGroupToShowInMap,{
                    id: device?.id,
                    mac: device?.deviceMac,
                    name: device?.name,
                    groupId: device?.groupId,
                    color: 'lightgrey',
                    checked: true,
                    position: {
                      latitude: device?.position?.latitude,
                      longitude: device?.position?.longitude,
                      elevation: device?.position?.elevation,
                      orientation: device?.position?.orientation
                    }
                  })
                })
              }
            })
          }

          localStorage.setItem('devicesWithGroupToShowInMap', JSON.stringify(devicesWithGroupToShowInMap))
          localStorage.setItem('devicesWithNoGroupToShowInMap', JSON.stringify(devicesWithNoGroupToShowInMap))

          const getDifference = (listGroupChecked: any, devicesWithGroupToShowInMap: any) => {
            const diffFromA1toA2 = listGroupChecked.filter((obj1: any) =>
              !devicesWithGroupToShowInMap.some((obj2: any) => obj1.groupId === obj2.groupId || obj1.id === obj2.groupId)
            );

            const diffFromA2toA1 = devicesWithGroupToShowInMap.filter((obj2: any) =>
              listGroupChecked.some((obj1: any) => obj2.groupId === obj1.groupId || obj2.groupId === obj1.id)
            );

            diffFromA2toA1.checked = true
            diffFromA1toA2.checked = true

            return [...diffFromA1toA2, ...diffFromA2toA1];
          }

          /* update the grouped devices position  */
          let updatedListGroupsChecked: any[] = []
          const groupChecked: any = localStorage.getItem('groupChecked')
          const groupsChecked: any = JSON.parse(groupChecked)
          if (groupChecked != '[]' && groupChecked != '') {
            updatedListGroupsChecked = (getDifference(groupsChecked, devicesWithGroupToShowInMap));
          }

          /* update the no-grouped devices position  */
          const updatedListNoGroupChecked: any[] = []
          let noGroupChecked: any = localStorage.getItem('noGroupChecked')
          if (noGroupChecked != '[]' && noGroupChecked != '') {
            devicesWithNoGroupToShowInMap.forEach((updatedGroup: any) => {
              updatedListNoGroupChecked.push(updatedGroup);
            });
          }

        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
        });
    }

    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
        });
    }
  }

  const handleChangeZone = (ev: any, zoneId: any) => {
    let checked: any = ev.target.element.checked;
    let listZoneChecked: any[] = zoneCheckedList
    let zonesCheckboxListByMap: any[] = zonesCheckboxByMap
    let zonesChecked: any[] = localStorage.getItem('zonesChecked') ? JSON.parse(localStorage.getItem('zonesChecked') as string) : []

    let zoneCtx: any;    

    //manage checkbox "selectall"
    if(zoneId == 0){
      if(!checked){
        const updatedZones = zonesCheckboxByMap.map((zone: any) => ({
          ...zone,
          checked: false
        }));
    
        setZoneCheckedList(updatedZones);
        setZonesCheckboxByMap(updatedZones);
        zonesChecked = updatedZones;
    
        if (zoneCanvas.current != null || currentZoneCanvas.current != null) {
          zoneCtx = zoneCanvas?.current?.getContext("2d") ?? currentZoneCanvas?.current?.getContext("2d");
          zoneCtx.clearRect(0, 0, zoneCanvas.width, zoneCanvas.height);
        }
    
        localStorage.setItem('zonesChecked', JSON.stringify([]));
      } else {
        const updatedZones = zonesCheckboxListByMap.map((zone: any) => ({
          ...zone,
          checked: true
        }));
    
        setZoneCheckedList(updatedZones);
        setZonesCheckboxByMap(updatedZones);
        zonesChecked = updatedZones;
    
        localStorage.setItem('zonesChecked', JSON.stringify(updatedZones));
      }
    }
    

    //manage single checkbox
    if (zoneId != 0) {     
      if (!checked) {
        zonesCheckboxByMap.map((zone: any) => {
          if(zone.id == zoneId){
            zone.checked = false
            zonesChecked.splice(zoneId, 1);  // Removes 1 element at the found index
          }
        })
        zonesChecked = zonesChecked.filter(item => item.id !== zoneId);
      } else {
        zonesCheckboxByMap.map((zone: any) => {
          if(zone.id == zoneId){
            zone.checked = true
            zonesChecked.push(zone)
          }
        })
      }
      setZonesCheckboxByMap(zonesCheckboxByMap)
      setZoneCheckedList(zonesChecked)
      localStorage.setItem('zonesChecked', JSON.stringify(zonesChecked));

    }

    
    if (zoneCanvas.current != null || currentZoneCanvas.current != null) {
      zoneCtx = zoneCanvas?.current?.getContext("2d") ?? currentZoneCanvas?.current?.getContext("2d");
      zoneCtx.clearRect(0, 0, zoneCanvas.width, zoneCanvas.height)
    }

    // re-render the zone canvas after deleting a zone deselected
    if (zonesChecked.length > 0 && !mapGeoreferenced) {
      zonesChecked.forEach((zone: any) => {
        if (zone.id != 0 && zone.checked) {
          zoneCtx.beginPath();
          zoneCtx.fillStyle = zone.color
          zoneCtx.moveTo(zoneCanvas.width * zone.points[0].longitude, zoneCanvas.height - zoneCanvas.height * zone.points[0].latitude);
          zone.points.forEach((points: any) => {
            zoneCtx.lineTo(zoneCanvas.width * points.longitude, zoneCanvas.height - (zoneCanvas.height * points.latitude));
          });
          zoneCtx.globalAlpha = 0.8;
          zoneCtx.fill();
        }
      });
    }
    
  };

  const handleChangeGroup = (ev?: any, groupId?: any, fromSynopticGrid?: boolean) => {

    let checked: any = ev?.target?.element?.checked ?? ev;
    let updatedDeviceWithGroupsToShowInMap: any = localStorage.getItem('devicesWithGroupToShowInMap') ? JSON.parse(localStorage.getItem('devicesWithGroupToShowInMap') as string) : []
    let groupChecked: any = localStorage.getItem('groupChecked') ? JSON.parse(localStorage.getItem('groupChecked') as string) : []
    let noGroupChecked: any = localStorage.getItem('noGroupChecked') ? JSON.parse(localStorage.getItem('noGroupChecked') as string) : []
    let updatedDevicesWithNoGroupToShowInMap: any = localStorage.getItem('devicesWithNoGroupToShowInMap') ? JSON.parse(localStorage.getItem('devicesWithNoGroupToShowInMap') as string) : []
    
    let localeListGroups: any = JSON.parse(localStorage.getItem('listGroups') as string)

    let groupsCheckboxListByMap:any = groupsCheckboxByMap

    //manage checkbox "selectall"
    if(groupId == 0){      
      if(!checked){
        groupChecked = []
        groupsCheckboxListByMap.forEach((group:any) => {
          group.checked = false
        });
      }else{
        groupsCheckboxListByMap.forEach((group:any) => {
          group.checked = true
        });             
        groupChecked = updatedDeviceWithGroupsToShowInMap
      }

      setGroupsCheckboxByMap(groupsCheckboxListByMap)
      localStorage.setItem('groupChecked', updatedDeviceWithGroupsToShowInMap)
    }
    
    //manage single checkbox
    if (groupId != null && groupId != 0 && groupId != 1) {
      if (fromSynopticGrid) {
        localeListGroups.forEach((group: any) => {

          if(onlyBound){
            if(group?.name == '' || group?.name == null){
              return
            }
          }

          if (group?.id == groupId) {
            if (!checked) {
              groupChecked = groupChecked.filter((item:any) => item.groupId == groupId);
            } else {
              group.checked = true
              groupChecked.push(group)
            }
          }
        });
      } 
      else if(updatedDeviceWithGroupsToShowInMap.length > 0){
        updatedDeviceWithGroupsToShowInMap.forEach((group: any) => {

          if(onlyBound){
            if(group?.name == '' || group?.name == null){
              return
            }
          }

          if (group?.groupId == groupId) {
            if (!checked) {
              group.checked = false
              groupsCheckboxByMap.map((group: any) => {
                if(group.id == groupId){
                  group.checked = false
                }
              })
              groupChecked = groupChecked.filter((item:any) => item.groupId !== groupId);
            } else {
              group.checked = true
              groupsCheckboxByMap.map((group: any) => {
                if(group.id == groupId){
                  group.checked = true
                }
              })
              groupChecked.push(group)
            }
          }else{
            if (!checked) {
              group.checked = false
            }else{
              group.checked = true
            }
          }
        });
      }
      else{
        if (!checked) {
          groupsCheckboxByMap.map((group: any) => {
            if(group.id == groupId){
              group.checked = false
            }
          })
          groupChecked = groupChecked.filter((item:any) => item.groupId !== groupId);
        } else {
          groupsCheckboxByMap.map((group: any) => {
            if(group.id == groupId){
              group.checked = true
              groupChecked.push(group)
            }
          })
        }
      }
      setGroupsCheckboxByMap(groupsCheckboxByMap)
    }
    else {
      updatedDevicesWithNoGroupToShowInMap?.forEach((group: any) => {
        if (!checked) {
          groupsCheckboxByMap?.map((group: any) => {
            if(group.id == groupId){
              group.checked = false
            }
          })
          groupChecked = groupChecked?.filter((item:any) => item.id !== group.id);
        } else {
          group.checked = true          
          groupChecked = groupChecked?.filter((item:any) => item.id !== group.id);
          groupChecked.push(group)
          groupsCheckboxByMap?.map((group: any) => {
            if(group.id == groupId){
              group.checked = true
            }
          })
        }
      })
    }


    const allGroupsChecked = groupChecked.concat(noGroupChecked);
    localStorage.setItem('groupChecked', JSON.stringify(allGroupsChecked));    
    setGroupsChecked(allGroupsChecked)
    

    let groupCtx: any;
    if (groupCanvas.current != null || currentZoneCanvas.current != null) {
      groupCtx = groupCanvas?.current?.getContext("2d") ?? currentZoneCanvas?.current?.getContext("2d");
      groupCtx.clearRect(0, 0, groupCanvas.width, groupCanvas.height)
    }

    // re-render the group canvas after deleting a group selected
    if (groupChecked.length > 0 && groupCtx != null && !mapGeoreferenced) {
      groupChecked.forEach((group: any) => {
        groupCtx.fillStyle = group?.color
        groupCtx.lineWidth = 2;
        groupCtx.strokeStyle = 'black';
        groupCtx.beginPath();
        groupCtx.arc(Math.round(groupCanvas.width * group?.position?.longitude) - 5, Math.round(groupCanvas.height - groupCanvas.height * group?.position?.latitude) - 5, 10, 0, Math.PI * 2);
        groupCtx.closePath();
        groupCtx.fill();
        groupCtx.stroke();
      });
    }

    // re-render the group canvas after deleting a group deselected
    if (noGroupChecked.length > 0 && groupCtx != null && !mapGeoreferenced) {
      noGroupChecked.forEach((group: any) => {
        groupCtx.fillStyle = 'lightgrey' //group.color
        groupCtx.lineWidth = 2;
        groupCtx.strokeStyle = 'black';
        groupCtx.beginPath();
        groupCtx.arc(Math.round(groupCanvas.width * group?.position?.longitude) - 5, Math.round(groupCanvas.height - groupCanvas.height * group?.position?.latitude) - 5, 10, 0, Math.PI * 2);
        groupCtx.closePath();
        groupCtx.fill();
        groupCtx.stroke();
      });
    }

  };
 
  const handleChangeGroupMapGeo = (ev?: any, groupId?: any, fromSynopticGrid?: boolean) => {

    setGroupChanged(!groupChanged)
   
    let checked: any = ev?.target?.element?.checked ?? ev;
    let updatedDeviceWithGroupsToShowInMap: any = localStorage.getItem('devicesWithGroupToShowInMap') ? JSON.parse(localStorage.getItem('devicesWithGroupToShowInMap') as string) : []
    let groupChecked: any = localStorage.getItem('groupChecked') ? JSON.parse(localStorage.getItem('groupChecked') as string) : []
    let noGroupChecked: any = localStorage.getItem('noGroupChecked') ? JSON.parse(localStorage.getItem('noGroupChecked') as string) : []
    let updatedDevicesWithNoGroupToShowInMap: any = localStorage.getItem('devicesWithNoGroupToShowInMap') ? JSON.parse(localStorage.getItem('devicesWithNoGroupToShowInMap') as string) : []
    
    let localeListGroups: any = JSON.parse(localStorage.getItem('listGroups') as string)

    let groupsCheckboxListByMap:any = groupsCheckboxByMap

    //manage checkbox "selectall"
    if(groupId == 0){
      if(!checked){
        groupChecked = []
        groupsCheckboxListByMap.forEach((group:any) => {
          group.checked = false
        });
      }else{
        groupsCheckboxListByMap.forEach((group:any) => {
          group.checked = true
        });      
        groupChecked = updatedDeviceWithGroupsToShowInMap
      }

      setGroupsCheckboxByMap(groupsCheckboxListByMap)
      localStorage.setItem('groupChecked', updatedDeviceWithGroupsToShowInMap)
    }
    
    //manage single checkbox
    if (groupId != null && groupId != 0 && groupId != 1) {
      if (fromSynopticGrid) {
        localeListGroups.forEach((group: any) => {

          if(onlyBound){
            if(group?.name == '' || group?.name == null){
              return
            }
          }

          if (group?.id == groupId) {
            if (!checked) {
              groupChecked = groupChecked?.filter((item:any) => item.groupId == groupId);
            } else {
              group.checked = true
              groupChecked.push(group)
            }
          }
        });
      } 
      else if(updatedDeviceWithGroupsToShowInMap.length > 0){
        updatedDeviceWithGroupsToShowInMap?.forEach((group: any) => {

          if(onlyBound){
            if(group?.name == '' || group?.name == null){
              return
            }
          }

          if (group?.groupId == groupId) {
            if (!checked) {
              group.checked = false
              groupsCheckboxByMap.map((group: any) => {
                if(group.id == groupId){
                  group.checked = false
                }
              })
              groupChecked = groupChecked?.filter((item:any) => item.groupId !== groupId);
            } else {
              group.checked = true
              groupsCheckboxByMap?.map((group: any) => {
                if(group.id == groupId){
                  group.checked = true
                }
              })
              groupChecked.push(group)
            }
          }
        });
      }
      else{
        if (!checked) {
          groupsCheckboxByMap?.map((group: any) => {
            if(group.id == groupId){
              group.checked = false
            }
          })
          groupChecked = groupChecked?.filter((item:any) => item.groupId !== groupId);
        } else {
          groupsCheckboxByMap?.map((group: any) => {
            if(group.id == groupId){
              group.checked = true
              groupChecked.push(group)
            }
          })
        }
      }
      setGroupsCheckboxByMap(groupsCheckboxByMap)
    }
    else {
      updatedDevicesWithNoGroupToShowInMap?.forEach((group: any) => {
        if (!checked) {
          groupsCheckboxByMap?.map((group: any) => {
            if(group.id == groupId){
              group.checked = false
            }
          })
          groupChecked = groupChecked?.filter((item:any) => item.id !== group.id);
        } else {
          group.checked = true          
          groupChecked = groupChecked?.filter((item:any) => item.id !== group.id);
          groupChecked.push(group)
          groupsCheckboxByMap?.map((group: any) => {
            if(group.id == groupId){
              group.checked = true
            }
          })
        }
      })
    }
        
    const allGroupsChecked = groupChecked.concat(noGroupChecked);
    localStorage.setItem('groupChecked', JSON.stringify(allGroupsChecked));    
    setGroupsChecked(allGroupsChecked)

  };

  // toggle checkbox beacon and render beacon in map
  const handleChangeBeacon = (ev: any, beaconIdSelected?: any, fromBeaconGrid?: []) => {
    
    let checked: any = ev?.target?.element?.checked ?? ev;
    //let currentItemValue: any = ev?.target?.element?.value;
    const listBeaconChecked: any[] = []

    const beaconCtx = beaconCanvas?.current?.getContext("2d");
    const beaconWidth = 40;
    const beaconHeight = 25;

    const updatedBeaconsList:any = []

    if (beaconIdSelected == '0') { // select all
      listBeaconsOn.forEach((beacon: any) => {        
        if (checked) {
          beacon.checked = true
          listBeaconChecked.push(beacon)
        } 
        else {
          beacon.checked = false
          beaconCtx.clearRect(0 - beaconWidth / 2, 0 - beaconHeight / 2, beaconCanvas.width + beaconWidth / 2, beaconCanvas.height + beaconHeight / 2)
        }
      });
      setListBeaconsOn(listBeaconsOn)
      setAllBeacons(listBeaconsOn)   
      localStorage.setItem('beaconsByMapId', JSON.stringify(listBeaconsOn))
    }
    else {
      if (fromBeaconGrid != null) {
        fromBeaconGrid.forEach((beacon: any) => {
          if (beacon.id == beaconIdSelected) {
            if (checked) {
              beacon.checked = true
              listBeaconChecked.push(beacon)
            } else {
              beacon.checked = false
              beaconCtx.clearRect(0 - beaconWidth / 2, 0 - beaconHeight / 2, beaconCanvas.width + beaconWidth / 2, beaconCanvas.height + beaconHeight / 2)
            }
          }
        });
        setListBeaconsOn(fromBeaconGrid)
        setAllBeacons(fromBeaconGrid)
        localStorage.setItem('beaconsByMapId', JSON.stringify(fromBeaconGrid))
      }
      else {
        listBeaconsOn.forEach((beacon: any) => {
          if (beacon.id == beaconIdSelected) {
            if (checked) {
              beacon.checked = true
              listBeaconChecked.push(beacon)
            } else {
              beacon.checked = false
              beaconCtx.clearRect(0 - beaconWidth / 2, 0 - beaconHeight / 2, beaconCanvas.width + beaconWidth / 2, beaconCanvas.height + beaconHeight / 2)              
            }
          }
        });        
        updatedBeaconsList.push(listBeaconsOn)
        setListBeaconsOn(listBeaconsOn)
        setAllBeacons(listBeaconsOn)
        localStorage.setItem('beaconsByMapId', JSON.stringify(listBeaconsOn))
      }
    }

    // re-render the beacon canvas 
    if (listBeaconsOn.length > 0) {
      listBeaconsOn.forEach((beacon: any) => {
        if (beacon.checked) {
          beaconCtx.beginPath();
          beaconCtx.fillStyle = beacon?.color
          beaconCtx.lineWidth = 2;
          beaconCtx.strokeStyle = 'black';
          
          const width = beaconCanvas.width ?? beaconCanvas.current.width
          const height = beaconCanvas.height ?? beaconCanvas.current.height

          const x = width * beacon.longitude;
          const y = height - height * beacon.latitude;
          beaconCtx.fillRect(x - beaconWidth / 2, y - beaconHeight / 2, beaconWidth, beaconHeight);
          beaconCtx.strokeRect(x - beaconWidth / 2, y - beaconHeight / 2, beaconWidth, beaconHeight);
        }
      });
    }
    if (fromBeaconGrid != null) {
      fromBeaconGrid.forEach((beacon: any) => {
        if (beacon.checked) {
          beaconCtx.beginPath();
          beaconCtx.fillStyle = beacon?.color
          beaconCtx.lineWidth = 2;
          beaconCtx.strokeStyle = 'black';
          const x = beaconCanvas.width * beacon.longitude;
          const y = beaconCanvas.height - beaconCanvas.height * beacon.latitude;
          beaconCtx.fillRect(x - beaconWidth / 2, y - beaconHeight / 2, beaconWidth, beaconHeight);
          beaconCtx.strokeRect(x - beaconWidth / 2, y - beaconHeight / 2, beaconWidth, beaconHeight);
        }
      });
    }

  };

  const [selectedBeacons, setSelectedBeacons] = useState<any[]>([]);
  // Sync initial state from listBeaconsOn
  useEffect(() => {
    setSelectedBeacons(allBeacons.filter((b: any) => b.checked));
  }, [allBeacons]);

  const onChange = (event: any) => {
    const newSelectedIds = event.value.map((b: any) => b.id);

    const newSelected = listBeaconsOn.filter((b: any) => newSelectedIds.includes(b.id));

    const added = newSelected.filter((b: any) => !selectedBeacons.some((s: any) => s.id === b.id));
    const removed = selectedBeacons.filter((s: any) => !newSelected.some((b: any) => b.id === s.id));

    localStorage.removeItem("beaconId");

    added.forEach((beacon: any) => {
      handleChangeBeacon({ target: { element: { checked: true } } }, beacon.id);
    });

    removed.forEach((beacon: any) => {
      handleChangeBeacon({ target: { element: { checked: false } } }, beacon.id);
    });

    if(removed[0]?.id == '0'){
      setSelectedBeacons([]);
    }else{
      setSelectedBeacons(newSelected);
    }
  };

  useEffect(() => {
    const initiallyChecked = listBeaconsOn.filter((b: any) => b.checked);
    setSelectedBeacons(initiallyChecked);
    filterChange2({ filter: { value: '' } });
  }, [listBeaconsOn]);

  const customFilterBeacons = (data: any[], filterText: string) => {
    const lowerFilter = filterText.toLowerCase();
    return data.filter(item => 
      (item.name && item.name.toLowerCase().includes(lowerFilter)) ||
      (item.id && item.id.toString().toLowerCase().includes(lowerFilter))
    );
  };

  const filterChange2 = (event: any) => {
    const filterText = event.filter?.value || '';
    const filtered = filterText ? customFilterBeacons(allBeacons, filterText) : allBeacons;
    setListBeaconsOn(filtered);
  };
  
  const tagRender = (tagData: any, tag: React.ReactElement) => {
    const item = tagData?.data[0];
    return (
      <span 
        style={{
          width: '100%',
          whiteSpace: 'break-spaces',
          borderBottom: '1px solid #ccc'
        }}>
        {item?.id} 
        <br />
        {item?.name}
      </span>
    );
  };
  
  const filterChange = (event:any) => {
    const filtered = filterBy(allBeacons.slice(), event.filter);
    setListBeaconsOn(filtered);
  };

  const itemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: any) => {
    const item = itemProps?.dataItem;
    if (!item) return li;

    return (
      <div onClick={(e) => e.stopPropagation()}>
        <Checkbox
          name={`${item?.id} - ${item?.name}`}    
          size={'small'}
          onChange={(e: any) => {          
            localStorage.removeItem('beaconId')
            handleChangeBeacon(e, item?.id)
            filterChange(e)
          }}
          label={
            <div style={{ borderBottom: '1px solid #ccc'}}>
              {item?.id}<br />{item?.name}
            </div>
          }  
          checked={item?.checked}
        >
          <label className="checkbox-label-beacon" style={{ background: item?.color }} />
        </Checkbox>
      </div>
    );
  };

  const handleChangeAlarm = (ev: any) => {
    let checked: any = ev?.target?.element?.checked ?? ev;

    const alarmCtx = alarmCanvas?.current?.getContext("2d");
    const alarmWidth = 40;
    const alarmHeight = 25;

    if (alarmChecked != null) {
      if (checked) {
        alarmChecked.checked = true
        setAlarmToggle(true)
        
      }
      else {
        if (alarmChecked?.checked == true) {
          delete alarmChecked.checked
          alarmCtx.clearRect(0 - alarmWidth / 2, 0 - alarmHeight / 2, alarmCanvas.width + alarmWidth / 2, alarmCanvas.height + alarmHeight / 2)
        }
        setAlarmToggle(false)
      }

      if (alarmChecked.checked && alarmCtx != null) {
        alarmCtx.beginPath();
        alarmCtx.fillStyle = 'red'
        alarmCtx.lineWidth = 2;
        alarmCtx.strokeStyle = 'black';

        const width = alarmCanvas.width ?? alarmCanvas.current.width
        const height = alarmCanvas.height ?? alarmCanvas.current.height

        const x = width * alarmChecked?.info?.position?.longitude;
        const y = height - height * alarmChecked?.info?.position?.latitude;
        alarmCtx.fillRect(x - alarmWidth / 2, y - alarmHeight / 2, alarmWidth, alarmHeight);
        alarmCtx.strokeRect(x - alarmWidth / 2, y - alarmHeight / 2, alarmWidth, alarmHeight);
      }

    }
  };

  const getAlarmPositionByWakeupId = async (wakeupId:any, mapsList:any) => {

    setLoading(true);

    let languageId = localStorage.getItem('languageId');

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      
      await axios.get(`${SERVER_URL}/wakeup/${wakeupId}`, { headers })
        .then((res) => {
          const data = res?.data.data

          setAlarmInfo(data)

          getMapByPosition(data.position.longitude, data.position.latitude, data.position.elevation, data.position.orientation, mapsList)
          
          setLoading(false);          

        }).catch(() => {
          setLoading(false);
        });
    }

    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
    }
  }

  const getAlarmRelativePositionsById = async (alarmId:any, mapId:any) => {

    setLoading(true);

    let languageId = localStorage.getItem('languageId');

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      
      await axios.get(`${SERVER_URL}/alarm/getAlarmRelativePositionsById?alarmId=${alarmId}&mapId=${mapId}`, { headers })
        .then((res) => {
          const data = res?.data.data

          setAlarmInfo(data)
          setAlarmChecked(data)
          
          setLoading(false);          

        }).catch(() => {
          setLoading(false);
        });
    }

    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
    }
  }

  useEffect(() => {
    handleChangeAlarm(true)
  },[alarmChecked])

  const mapRef: any = useRef(null);
    
  const onToggleLive = (e:any) => {
    
    const liveStatus: any = e.value
    localStorage.setItem('liveStatus', JSON.stringify(liveStatus))
    setLiveStatus(liveStatus)
    
    const storedDevicesToShowInMap:any = localStorage.getItem('devicesWithGroupToShowInMap')
    const storedGroupsChecked:any = localStorage.getItem('groupChecked')
    const storedDevicesList:any = localStorage.getItem('devicesList')
    const groupsChecked = storedGroupsChecked != '' ? JSON.parse(storedGroupsChecked) : ''

    if(liveStatus){
      const hoursBefore: any = localStorage.getItem('regularTag') ?? 5 // value in hour    

      const devicesList: any = localStorage.getItem('devicesList') ? JSON.parse(localStorage.getItem('devicesList') as string) : ''

      let liveDevicesToShowInMap:any = []
      let dateBeforeHours:any = ''
      
      devicesList.map((device: any) => {        
        dateBeforeHours = getDateRange(hoursBefore)
        if(device?.lastPositionDate && compareDateTimes(device?.lastPositionDate, dateBeforeHours) == 1){
          liveDevicesToShowInMap.push(device)
        }      
      })
      localStorage.setItem('devicesWithGroupToShowInMap', JSON.stringify(liveDevicesToShowInMap))

      setGroupsChecked(liveDevicesToShowInMap)
    }else{
      localStorage.setItem('groupChecked', JSON.stringify(groupsChecked))

      const devicesToShowInMap:any = JSON.parse(storedDevicesList)
      setGroupsChecked(devicesToShowInMap)
    }
    let currentMapId:any = JSON.parse(localStorage.getItem('mapId') as string)

    if(mapGeoreferenced){
      refreshGroupPositionsInMapGeo(currentMapId, true)      
    }else{
      refreshGroupPositionsInStaticMap(currentMapId)
    }
  }

  const getDateRange = (hours:any) => {
    // Create a Date object from the input string
    const currentDate = new Date();

    // Subtract 5 hours from the current date
    currentDate.setHours(currentDate.getHours() - hours);

    const formattedDate = formatDateWithAMPM(currentDate)
  
    return formattedDate;
  }

  // Function to format the date in AM/PM format
  const formatDateWithAMPM = (date:any) => {

    // Extract date components
    const day = String(date.getDate()).padStart(2, '0'); // Day of the month, padded
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month, padded (months are 0-indexed)
    const year = date.getFullYear(); // Full year

    // Extract time components
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0'); // Minutes, padded
    const seconds = String(date.getSeconds()).padStart(2, '0'); // Seconds, padded
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle 0 hours case (midnight)
    
    // Return the formatted date with time in AM/PM format
  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  }

  // Function to convert AM/PM formatted time string into a Date object
  const convertToDate = (dateString:any) => {
    const [datePart, timePart, ampm] = dateString.split(' '); // Split date and time part
    const [month, day, year] = datePart.split('/'); // Split date into day, month, and year
    let [hours, minutes, seconds] = timePart.split(':'); // Split time into hours, minutes, and seconds
    
    hours = parseInt(hours);
    minutes = parseInt(minutes);
    seconds = parseInt(seconds);

    // Convert the 12-hour format to 24-hour format
    if (ampm === 'PM' && hours < 12) hours += 12;
    if (ampm === 'AM' && hours === 12) hours = 0;

    // Create a new Date object based on the parsed values
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  const compareDateTimes = (date1Str:any, date2Str:any) => {
    // Parse the dates into Date objects
    const date1 = convertToDate(date1Str);
    const date2 = convertToDate(date2Str);
  
    // Compare the milliseconds
    if (date1.getTime() < date2.getTime()) {
      return -1; // date1 is earlier
    } else if (date1.getTime() > date2.getTime()) {
      return 1; // date1 is later
    } else {
      return 0; // dates are equal
    }
  }
 
  const onToggleOnlyBound = (e:any) => {    
    const onlyBound: any = e.value
    localStorage.setItem('onlyBoundMap', JSON.stringify(onlyBound))
    setOnlyBound(onlyBound)  
    if(liveStatus){
      onToggleLive(liveStatus)
    }
  }
 
  const onToggleGeoStatic = (e:any) => {    
    const toggleGeoStatic: any = e.value
    localStorage.setItem('onToggleGeoStatic', JSON.stringify(toggleGeoStatic))
    localStorage.setItem('mapGeorefenced', JSON.stringify(toggleGeoStatic))    
    setToggleGeoStatic(toggleGeoStatic) 
    
    renderMap(selectedMap)

    if(toggleGeoStatic){
      localStorage.removeItem('beaconId');
      localStorage.removeItem('beaconMapId');
      localStorage.removeItem('beaconsByMapId');
      handleChangeMap(selectedMap.name, false)
      refreshGroupPositionsInMapGeo(selectedMap.id, true)
    }else{
      getZoneList(selectedMap.id, false)
      getBeaconList(selectedMap.id, true, false, false, null, false)   
      refreshGroupPositionsInStaticMap(selectedMap.id)
      if(alarmInfoSelected != null){        
        getAlarmRelativePositionsById(alarmInfoSelected.id, selectedMap.id)
      }
    }
  }

  useEffect(() => {
    if(!toggleGeoStatic){
      refreshGroupPositionsInStaticMap(selectedMap.id)      
    }
  },[onlyBound])


  const [transformState, setTransformState] = useState<any>([])
  const [tooltipContent, setTooltipContent] = useState("");
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);
  const [lastMouseEvent, setLastMouseEvent] = useState(null);
  const transformContentRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    if (lastMouseEvent) {
      handleMouseMove(lastMouseEvent);
    }
  }, [transformState]); // ogni volta che fai pan/zoom
  

  const handleMouseMove = (e: any) => {
    setLastMouseEvent(e);

    if (!transformContentRef.current) return;

    const { scale } = transformState;

    // Bounding box del contenitore trasformato
    const rect = transformContentRef.current.getBoundingClientRect();

    // Mouse position relativa al contenitore trasformato
    const mouseX = (e.clientX - rect.left) / scale + 5;
    const mouseY = (e.clientY - rect.top) / scale + 5;

    //device tooltips 
    let updatedListGroups: any = localStorage.getItem('groupChecked');
    if (!Array.isArray(updatedListGroups)) {
      if (typeof updatedListGroups === 'string' && updatedListGroups.trim() !== "") {
        updatedListGroups = JSON.parse(updatedListGroups);
      } else {
        updatedListGroups = [];
      }
    }
    
    let tooltipStr = '';
    let found = false;
    
    let deviceMac: any = localStorage.getItem('deviceMac');
    
    updatedListGroups.forEach((group: any) => {

      if(deviceMac != null){
        if(deviceMac == group.mac){
       
          const radius = 10;
        
          const groupX = group?.position?.longitude * mapImageWidth;
          const groupY = mapImageHeight - group?.position?.latitude * mapImageHeight;
          
          const distance = Math.hypot(mouseX - groupX, mouseY - groupY);
          
          if (distance <= radius) {
            tooltipStr += `<div>${localizationService.toLanguageString('map.name', 'NOT_FOUND')}: ${group.name}</div><div>Mac: ${group.mac}</div>--------------`;
            found = true;
          }
        }
        else if(group.checked){
          
          const radius = 10;
          
          const groupX = group?.position?.longitude * mapImageWidth;
          const groupY = mapImageHeight - group?.position?.latitude * mapImageHeight;
          
          const distance = Math.hypot(mouseX - groupX, mouseY - groupY);
          
          if (distance <= radius) {
            tooltipStr += `<div>${localizationService.toLanguageString('map.name', 'NOT_FOUND')}: ${group.name}</div><div>Mac: ${group.mac}</div>--------------`;
            found = true;
          }
        }
      }
      else if(group.checked){
        
        //const radius = 10 / scale;
        const radius = 10;
        
        const groupX = group?.position?.longitude * mapImageWidth;
        const groupY = mapImageHeight - group?.position?.latitude * mapImageHeight;

        const distance = Math.hypot(mouseX - groupX, mouseY - groupY);
        
        if (distance <= radius) {
          tooltipStr += `<div>${localizationService.toLanguageString('map.name', 'NOT_FOUND')}: ${group.name}</div><div>Mac: ${group.mac}</div>--------------`;
          found = true;
        }
      }
    });
    
    //beacons tooltips 
    let updatedListBeacons: any = localStorage.getItem('beaconsByMapId');
    if (!Array.isArray(updatedListBeacons)) {
      if (typeof updatedListBeacons === 'string' && updatedListBeacons.trim() !== "") {
        updatedListBeacons = JSON.parse(updatedListBeacons);
      } else {
        updatedListBeacons = [];
      }
    }

    updatedListBeacons.forEach((beacon: any) => {
      if(beacon.checked){                
        const radius = 10;

        const groupX = beacon?.longitude * mapImageWidth;
        const groupY = mapImageHeight - beacon?.latitude * mapImageHeight;

        const distance = Math.hypot(mouseX - groupX, mouseY - groupY);

        if (distance <= radius) {
          tooltipStr += `<div>${localizationService.toLanguageString('map.name', 'NOT_FOUND')}: ${beacon.name}</div><div>${localizationService.toLanguageString('map.type', 'NOT_FOUND')}: ${beacon.type}</div>`;
          found = true;
        }
      }
    });

    //alarm tooltips
    if(alarmChecked != null){
      const radius = 10;
      
      const groupX = alarmChecked?.info?.position?.longitude * mapImageWidth;
      const groupY = mapImageHeight - alarmChecked?.info?.position?.latitude * mapImageHeight;

      const distance = Math.hypot(mouseX - groupX, mouseY - groupY);
      
      if (distance <= radius) {
        tooltipStr += `<div>${localizationService.toLanguageString('map.date_time', 'NOT_FOUND')}: ${alarmChecked.name}</div><div>${localizationService.toLanguageString('map.type', 'NOT_FOUND')}: ${alarmChecked.dateTime}</div>`;
        found = true;
      }
    }


    if (found) {
      setTooltipContent(tooltipStr);
      setTooltipPos({ x: e.clientX + 10, y: e.clientY + 10 }); // Posizione assoluta nel viewport
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
  };

  return (

    <div 
      className="flex-parent-element-maps"
    >
      <NotificationGroup
          style={{
              right: 0,
              bottom: 50,
              alignItems: "flex-start",
              flexWrap: "wrap-reverse",
          }}
      >
        <Fade enter={true} exit={true}>
            {noPositionFound && (
                <Notification
                    type={{ style: "warning", icon: true }}
                    closable={true}
                    onClose={() => setNoPositionFound(false)}
                >
                    <span>{localizationService.toLanguageString('map.no_position_found', 'NOT FOUND')}</span>
                </Notification>
            )}            
          </Fade>
      </NotificationGroup>      
      {/*{listMaps.length == 0 && loadingPanel && loading}*/}
      {loadingPanel && loading}
      <div  
        className="flex-left-child-element canvas-container" 
        style={{ 
          width: '75%', 
          background: '#F7F7F7'
        }}
      >
        <div  
          ref={mapRef} 
          style={{ 
            height: '100%', 
            background: '#F7F7F7',
            display: mapGeoreferenced ? 'none' : 'block' 
          }}
        >
        
          <TransformWrapper
            initialScale={0.8}
            initialPositionX={0}
            initialPositionY={0}
            minScale={0.3}
            centerOnInit={true}
            centerZoomedOut={true}
            smooth={true}
            onTransformed={(_, state) => {
              setTransformState(state);
              if (lastMouseEvent) {
                handleMouseMove(lastMouseEvent);
              }
            }}
          >
            {({ zoomIn, zoomOut, resetTransform, centerView, zoomToElement, ...rest }) => (
              <>
                <Controls />
                { noMaps &&
                  // Mostra un messaggio o un altro contenuto se non ci sono dati
                  <div style={{ textAlign: 'center', padding: '20px'}}>
                      <p>{localizationService.toLanguageString('map.no_map', 'NOT_FOUND')}</p>
                  </div>
                }
                {showTooltip && (
                  <div
                    ref={tooltipRef}
                    onMouseMove={handleMouseMove}
                    style={{
                      position: "fixed",
                      top: tooltipPos.y,
                      left: tooltipPos.x,
                      backgroundColor: "white",
                      border: "1px solid black",
                      padding: "8px",
                      fontSize: "14px",
                      pointerEvents: "none",
                      zIndex: 9999,
                      boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.3)",
                      borderRadius: "4px",
                      transform: "translate(-50%, -50%)" // questo centra automaticamente rispetto alla posizione top/left
                    }}
                    dangerouslySetInnerHTML={{ __html: tooltipContent }}
                  />
                )}

                <TransformComponent 
                  wrapperStyle={{ 
                    width: '100%',
                    height: '100%'
                  }}     
                  contentStyle={{
                    width: mapImageWidth,
                    height: mapImageHeight,
                    position: 'relative'
                  }}        
                >
                  <div ref={transformContentRef} onMouseMove={handleMouseMove}>
                    <canvas
                      ref={mapCanvas}
                      className="mapCanvas"
                      width={1400}
                      height={2000}
                    />
                    <canvas
                      ref={zoneCanvas}
                      className="zoneCanvas"
                      width={1400}
                      height={1400}
                    />
                    <canvas
                      ref={beaconCanvas}
                      className="beaconCanvas"
                      width={1400}
                      height={1400}
                    />
                    <canvas
                      ref={alarmCanvas}
                      className="alarmCanvas"
                      width={1400}
                      height={1400}
                    />
                    <canvas
                      ref={groupCanvas}
                      className="groupCanvas"
                      width={1400}
                      height={1400}
                    />                  
                  </div>
                </TransformComponent>
              </>
            )}
          </TransformWrapper>
        </div>
        <div  
            ref={mapRef} 
            style={{ 
              height: '100%', 
              background: '#F7F7F7',
              display: !mapGeoreferenced ? 'none' : 'block' 
            }}
          >
            { listMaps.length != 0 && mapGeoreferenced && 
            <AzureMapComponent 
              map={selectedMap ?? localStorage.getItem('mapSelected')} 
              zones={JSON.parse(localStorage.getItem('zonesChecked') || '[]')} 
              groups={localStorage.getItem('groupChecked') ?? groupsChecked} 
              beacons={JSON.parse(localStorage.getItem('beaconsByMapId') || '[]')} 
              deviceMac={deviceMacSelected}
              groupChanged={groupChanged}
              onlyBound={onlyBound}
              alarmInfo={JSON.parse(localStorage.getItem('alarmInfoSelected') || '[]')}
              alarmToggle={alarmToggle}
              geoStaticToggle={toggleGeoStatic}
            />
            }            
          </div>
      </div>

      <div className="flex-right-child-element-maps" >
        {/* map list */}
        <h4 className="k-h4" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('map.map_list', 'NOT_FOUND')}</h4>
        <DropDownList
          data={listMapNames}
          value={mapName.length > 0 ? mapName : undefined}
          defaultItem={localizationService.toLanguageString('map.select_map', 'NOT_FOUND')}
          onChange={(e: any) => {            
            setShowDeviceMac(false);
            setDeviceMacSelected('')
            localStorage.removeItem('deviceMapId')
            localStorage.removeItem('deviceGroupId');

            // @ts-ignore
            if(listMapNames.includes(e.value)){
              localStorage.removeItem('beaconId');
              localStorage.removeItem('beaconMapId');
              localStorage.removeItem('beaconsByMapId');
              localStorage.removeItem('alarmInfoSelected');
              handleChangeMap(e, true)
            }
          }}
          //onOpen={()=>localStorage.removeItem('deviceMac')}
          style={{ width: "90%", color: '#018CA5', cursor: 'pointer' }}
          title={localizationService.toLanguageString('map.select_map', 'NOT_FOUND')}
        />
        <br />
        <br />

        {/*liveStatus*/}
        <div className="k-mb-2" >
            <Switch
                onChange={onToggleLive}
                disabled={mapId != '' ? false : true}
                checked={liveStatus}
            />
            <label className="k-ml-3">{localizationService.toLanguageString('map.live', 'NOT_FOUND')}</label>
        </div>

        {/*onlyBound*/}
        <div className="k-mb-2">
            <Switch
              onChange={onToggleOnlyBound}
              checked={onlyBound}
          />
          <label style={{margin:'0 auto'}} className="k-ml-3">{localizationService.toLanguageString('synoptic_devices.only_binded', 'NOT_FOUND')}</label>
        </div>
        
        {/*toggleGeoStatic*/}
        { selectedMap?.georeferenced == 1 && selectedMap?.image != '' &&
          <div className="k-mb-2">
              <Switch
                onChange={onToggleGeoStatic}
                checked={toggleGeoStatic}
            />
            <label 
              style={{margin:'0 auto'}} 
              className="k-ml-3"
            >
              { toggleGeoStatic ?
                localizationService.toLanguageString('map.geo', 'NOT_FOUND')
                :
                localizationService.toLanguageString('map.static', 'NOT_FOUND')            
              }
            </label>
          </div>
        }

        <br />

        {/*filter device*/}
        <div style={{display: `${showDeviceMac ? 'block' : 'none'}`}} >
          <div 
            className="trash-icon" 
            style={{
                float: 'left',
                cursor: 'pointer',
                alignContent: 'center',
                marginRight: '10px'
            }}
            title={localizationService.toLanguageString('configuration.rules.timeslot_remove', 'NOT FOUND')}
            onClick={()=>{
              if(!toggleGeoStatic){
                refreshGroupPositionsInStaticMap(selectedMap.id)                  
              }
              setShowDeviceMac(false);
              setDeviceMacSelected('')
              localStorage.removeItem('deviceMac');
              localStorage.removeItem('mapSelected');

              //window.location.reload();
            }} 
          >
            <Avatar       
                className="trash-icon"     
            >
              <SvgIcon                                             
                  icon={trashIcon} 
                  style={{ verticalAlign: 'baseline', margin: '10px' }} 
              />
            </Avatar>
          </div>
          <p
            style={{
                marginLeft: '10px',
                padding: '10px'
            }}          
          >
            <label className="k-mb-2">Mac: {deviceMac}</label>
          </p>
        </div>
        
        <br />
        <br />

        {/* zone list */}
        {/*{loading && loadingPanel}*/}
        <h4 className="k-h4" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('map.zone_list', 'NOT_FOUND')}</h4>
        {zonesCheckboxByMap.map((zone: any, index: any) => {
          return (
            <>
              <Checkbox
                key={index}
                name={zone?.name ?? zone}
                defaultValue={true}
                //value={zone?.name ?? zone}
                onChange={(e: any) => handleChangeZone(e, zone?.id)}
                label={zone?.id ? zone?.id + ': ' + zone.name : zone}
                checked = {zone.checked ?? false}
              >
                <label className="checkbox-label-zone" style={{ background: zone?.color }} />
              </Checkbox>
            </>
          );
        })}
        <br />
        <br />

        {/* group list */}
        {/*{loading && loadingPanel}*/}
        <div>
            <p className="k-h4" style={{ color: '#018CA5' }}>
              {localizationService.toLanguageString('map.group_list', 'NOT_FOUND')}
            </p>
        {
          !mapGeoreferenced ?
            groupsCheckboxByMap?.map((group: any, index: any) => {
              return (
                <>
                  <Checkbox
                    key={index}
                    name={group?.name ?? group}
                    defaultValue={true}
                    value={group?.name ?? group}
                    onChange={(e: any) => handleChangeGroup(e, group?.id)}
                    label={group?.id ? group?.id + ': ' + group.name : group}
                    checked = {group.checked}
                  >
                    <label className="checkbox-label-group" style={{ background: group?.color }} />
                  </Checkbox>
                </>
              );
            })
            :
            groupsCheckboxByMap?.map((group: any, index: any) => {
              return (
                <>
                  <Checkbox
                    key={index}
                    name={group?.name ?? group}
                    defaultValue={true}
                    value={group?.name ?? group}
                    onChange={(e: any) => handleChangeGroupMapGeo(e, group?.id)}
                    label={group?.id ? group?.id + ': ' + group.name : group}
                    checked = {group.checked}
                  >
                    <label className="checkbox-label-group" style={{ background: group?.color }} />
                  </Checkbox>
                </>
              );
            })
        }
        </div>
        <br />
        <br />

        {/* beacon list */}
        {/*{loading && loadingPanel}*/}
        <div style={{ display: 'inline-table', width: '90%' }}>
          <h4 className="k-h4" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('beacons.title', 'NOT_FOUND')}</h4>
          { loading && loadingPanel}
          <MultiSelect
            data={listBeaconsOn}
            //textField="mac"
            textField="id"
            dataItemKey="id"
            value={selectedBeacons}
            onChange={onChange}
            itemRender={itemRender}
            autoClose={false}
            filterable={true}
            onFilterChange={filterChange2}
            onFocus={filterChange2}
            tagRender={tagRender} 
            placeholder={localizationService.toLanguageString('beacons.select_beacon', 'NOT_FOUND')}
          />
          {/*{listBeaconsOn?.map((beacon: any, index: any) => {
            return (
              <Checkbox
                key={index}
                name={beacon?.name}
                onChange={(e: any) => {
                  localStorage.removeItem('beaconId')
                  handleChangeBeacon(e, beacon?.id)
                }}
                label={beacon?.name ?? ''}
                checked={beacon?.checked}
              >
                <label className="checkbox-label-beacon" style={{ background: beacon?.color }} />
              </Checkbox>
              );
            })
          }*/}
        </div>
        <br />
        <br />

        {/* alarm checkbox */}
        {loading && loadingPanel}
        {alarmChecked &&
          <>
            <h4 className="k-h4" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('map.alarm', 'NOT_FOUND')}</h4>
            <Checkbox
              name={alarmChecked?.name}
              //value={alarmChecked?.checked ?? undefined}
              value={alarmToggle ?? undefined}
              onChange={(e: any) => {
                handleChangeAlarm(e)
                setAlarmInfo(alarmChecked)
              }}
              label={alarmChecked?.name}
            >
              <label className="checkbox-label-beacon" style={{ background: 'red' }} />
            </Checkbox>
          </>
        }
        <br />
        <br />
        {/*}*/}
      </div>
    </div>
  )
}